import { c as _c } from "react/compiler-runtime";
import { useCallback, useSyncExternalStore } from 'react';
import { usePathname } from 'next/navigation';

// No need to subscribe because the is handled by
// the changing pathname in useNavigationKey.
const subscribeToNavigation = () => {
  return () => {};
};
const getServerNavigationKeySnapshot = () => {
  return undefined;
};

/**
 * Gets a unique key for the current navigation entry.
 * If the Navigation API is not supported, falls back to using the pathname.
 *
 * The same pathname may appear multiple times in the navigation history.
 * For example when navigation away from a page and then click a link back to it.
 */
const getNavigationKey = (pathname: string) => {
  if (window.navigation == null) {
    return pathname;
  }
  const entries = window.navigation.entries();
  const currentEntry = window.navigation.currentEntry;
  const currentEntryIndex = currentEntry != null ? entries.indexOf(currentEntry) : -1;
  let key: string | undefined = undefined;
  for (let index = currentEntryIndex; index >= 0; index -= 1) {
    const entry = entries[index];
    if (entry.url == null) continue;
    const entryPathname = new URL(entry.url).pathname;
    if (pathname != null && entryPathname !== pathname) {
      break;
    }
    key = entry.key;
  }
  return key;
};
export const useNavigationKey = () => {
  const $ = _c(2);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = () => getNavigationKey(pathname);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getNav = t0;
  const navigationKey = useSyncExternalStore(subscribeToNavigation, getNav, getServerNavigationKeySnapshot);
  return navigationKey ?? pathname;
};